import transformer from '@views/Mission/transformer';

import {
  LOADING_STATE_TOGGLE,
  SET_MISSION_DETAILS,
  SET_MISSION_RELATED,
  SET_MISSION_RATING,
  SET_PERMISSIONS,
  SET_APPLIED
} from '@stores/mutation-types';

import {
  TYPES,
  ACCESS
} from '@views/Mission/constants';

import {
  Main as Mission
} from '@services/App/mission';

const state = () => ({
  mission: null,
  related: [],
  permissions: {},
  loading: {
    mission: false,
    related: false,
    rating: false,
    favorite: false
  },
  rating: null,
  isApplied: false
});

const mutations = {
  [LOADING_STATE_TOGGLE]: (state, type) => {
    state.loading[type] = !state.loading[type];
  },

  [SET_PERMISSIONS]: (state, data) => {
    state.permissions = data;
  },

  [SET_MISSION_DETAILS]: (state, data) => {
    state.mission = data;
  },

  [SET_MISSION_RELATED]: (state, data) => {
    state.related = data;
  },

  [SET_MISSION_RATING]: (state, data) => {
    state.rating = data;
  },

  [SET_APPLIED]: (state, data) => {
    state.isApplied = data;
  },
};

const actions = {
  async retrieveDetails({ commit }, { id, query }) {
    commit(LOADING_STATE_TOGGLE, 'mission');

    const response = await Mission.details(id, query);

    if (response.success) {
      commit(SET_MISSION_DETAILS, response.data);
    }

    commit(LOADING_STATE_TOGGLE, 'mission');

    return response;
  },

  async retrieveRelated({ commit, rootState }, id) {
    commit(LOADING_STATE_TOGGLE, 'related');

    const { success, data } = await Mission.related(id);

    if (success) {
      const transformed = data.map(mission => (
        transformer(mission, rootState.defaultLanguage)
      ));

      commit(SET_MISSION_RELATED, transformed);
    }

    commit(LOADING_STATE_TOGGLE, 'related');
  },

  async visit({ commit }, id) {
    const {
      success,
      data
    } = await Mission.visit(id);

    return success ? data : null;
  }
};

const getters = {
  isDonationMission: (state) => {
    if (!state.mission) {
      return false;
    }

    return state.mission.mission_type === TYPES.DONATION;
  },

  isVolunteeringMission: (state) => {
    if (!state.mission) {
      return false;
    }

    return [
      TYPES.TIME,
      TYPES.GOAL
    ].includes(state.mission.mission_type)
  },

  isTimeMission: (state) => {
    return state.mission.mission_type === TYPES.TIME;
  },

  isGoalMission: (state) => {
    return state.mission.mission_type === TYPES.GOAL;
  },

  isRestricted: (state) => {
    return state.mission.access === ACCESS.RESTRICTED;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
